import React from 'react';
import { connect } from 'react-redux';
import InfoBanner from '../info-banner';
import OnlineOnboardingStepper from '../online-onboarding-stepper';

const OnlineOnboardingBanner = ({ currentStep, insured }) => {
  return (
    <InfoBanner>
      <OnlineOnboardingStepper currentStep={currentStep} insured={insured} />
    </InfoBanner>
  );
};

const mapStateToProps = (state) => ({
  insured: state.onboarding?.insured,
});

export default connect(mapStateToProps)(OnlineOnboardingBanner);
